export function getImageSrc(imageName: string): string {
  if (window.location.hostname === 'localhost') {
    return `/assets/${imageName}`;
  }
  return `https://vstatic-prod.apigateway.co/wsp-admin-center-client.9223372035064099101.prod/assets/${imageName}`;
}
